module.exports = __webpack_public_path__ + "static/media/bulldozer.f696f7b4.jpg";